module.exports = __webpack_public_path__ + "templates.shopline_product_review-7378bc83.html";